import { Injectable } from '@angular/core';
import { Router, GuardsCheckEnd, ActivationEnd, ActivatedRouteSnapshot, NavigationExtras } from '@angular/router';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { Subscription } from 'rxjs/internal/Subscription';
import { filter, tap } from 'rxjs/operators';
import { ModalStack } from '../internals/modal-stack';
import { Location } from '@angular/common';

@Injectable()
export class NavigationService {
    
  private browserHistoryBackSubscription: Subscription;
  private navigationSubscription: Subscription;
  private previousRouteSnapshot: ActivatedRouteSnapshot;

  constructor(private router: Router,
    private location: Location
  ) {
        this.navigationSubscription = this.router.events.pipe(
      filter(event => event instanceof ActivationEnd),
      tap(event => {
            if (event instanceof ActivationEnd) {
              if (this.previousRouteSnapshot && event.snapshot.component && this.previousRouteSnapshot.component != event.snapshot.component) {
                ModalStack.dismissAllModals('the modals were dismissed by navigation');
          }

          if (event.snapshot.component) {
                this.previousRouteSnapshot = event.snapshot;
          }
        }
      })
    ).subscribe();

    this.browserHistoryBackSubscription = fromEvent(window, 'popstate').subscribe(x => ModalStack.dismissAllModals('the modals were dismissed by navigation'));
  }

  public updateQueryParams(queryParamsData: {}, replaceHistoryState: boolean = false): Promise<boolean> {
        const urlTree = this.router.createUrlTree([]);
    urlTree.queryParams = queryParamsData;
    return this.router.navigateByUrl(urlTree, { replaceUrl: replaceHistoryState });
  }

  public navigateBack(data?: any) {
    
        if (ModalStack.isModalExists) {
          ModalStack.closeActiveModal(data);
    }
    else {
          if (window.history.length === 1) {
            this.router.navigateByUrl('/');
      }
      else {
    
        let subs: Subscription;

        subs = this.router.events
          .pipe(
            filter(
              (event: any) => {
                    return (event instanceof GuardsCheckEnd);
              }
            )
          ).subscribe((event: GuardsCheckEnd) => {
                subs.unsubscribe();
            if (event.shouldActivate === false) {
                  this.router.navigateByUrl('/');
            }
          })
        this.location.back();
      }
    }
  }

  navigate(url: string, queryParamsData?: {}, navigationExtras?: NavigationExtras): Promise<boolean> {
        url = url || '/';
    const urlTree = this.router.parseUrl(url);

    if (queryParamsData) {
          urlTree.queryParams = queryParamsData;
    }

    const navPromise = this.router.navigateByUrl(urlTree, navigationExtras);

    // return new Promise((resolve, reject) => {
        //   navPromise.then(x => {
        //     if (x) {
        //       ModalStack.closeAllModals();
    //     }

    //     resolve(x);
    //   }, x => reject(x));
    // });

    return navPromise;
  }

  navigateWithModal(url: string, size: 'sm' | 'md' | 'lg', queryParamsData?: {}) {
        url = url || '/';

    const urlTree = this.router.createUrlTree([url, { mode: 'modal', size: size }]);

    if (queryParamsData) {
          urlTree.queryParams = queryParamsData;
    }

    this.router.navigateByUrl(urlTree);
  }
}
